<template>
  <section>
    <game-intro></game-intro>
    <timer-bar></timer-bar>
    <game-cards></game-cards>
    <game-footer></game-footer>
    

  </section>
</template>

<script>
import GameIntro from "@/components/GameProfits/GameIntro";
import TimerBar from "@/components/GameProfits/TimerBar";
import GameCards from "@/components/GameProfits/GameCards";
import GameFooter from "@/components/GameProfits/GameFooter";


export default {
  components: {
    GameIntro,
    TimerBar,
    GameCards,
    GameFooter,
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 30px;
}
</style>